/** Acesso ao catálogo de definições (armas/armaduras) e pools de atributos. */
import { GameConfig } from "../config/GameConfig";
import type { AttrKey, EquipmentDefinition, EquipmentSlot, WeaponDefinition, ArmorDefinition } from "./EquipmentTypes";

const WEAPONS = GameConfig.equipment.weapons as readonly WeaponDefinition[];
const ARMOR = GameConfig.equipment.armor as readonly ArmorDefinition[];

const BY_ID = new Map<string, EquipmentDefinition>();
for (const w of WEAPONS) BY_ID.set(w.id, w);
for (const a of ARMOR) BY_ID.set(a.id, a);

export function definitionById(id: string): EquipmentDefinition | undefined {
  return BY_ID.get(id);
}
export function isWeaponDef(def: EquipmentDefinition): def is WeaponDefinition {
  return def.slot === "weapon";
}
export function weaponDefs(): readonly WeaponDefinition[] {
  return WEAPONS;
}
export function armorDefs(): readonly ArmorDefinition[] {
  return ARMOR;
}
export function allDefs(): EquipmentDefinition[] {
  return [...WEAPONS, ...ARMOR];
}

export interface PoolEntry {
  key: AttrKey;
  min: number;
  max: number;
}
export function poolFor(slot: EquipmentSlot): readonly PoolEntry[] {
  return GameConfig.equipment.pools[slot] as readonly PoolEntry[];
}
